angular.module('gym.calendar').directive('editEventScheduleLog', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/edit_event_schedule_log.html.slim'),
    scope: {
      event: '='
    },
    controller: ["$scope", "$rootScope", "Restangular", "flash", "TableService", function($scope, $rootScope, Restangular, flash, TableService) {
      var Logs, filters, gym;
      gym = $rootScope.gym;
      Logs = Restangular.one('gyms', gym.id).all('gym_logs');
      filters = {
        'filters[event_schedule_id]': $scope.event.event_schedule_id
      };
      return $scope.logTable = TableService.init({
        count: 10,
        getData: function(resolve, $params, beforeLoad) {
          var params;
          params = angular.extend({}, $params.url(), filters);
          beforeLoad(params);
          return Logs.getList(params).then(function(response) {
            $params.total(response.meta.total);
            return resolve(response);
          }, function() {
            return flash.error = "Request could not be completed. Please try again";
          });
        }
      });
    }]
  };
});
